// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"_ef37684","table":"_992f32b","toggleCell":"_ae34fc7","toggleGroup":"_1f68c2c","toggle":"_9377685"};